import { Component, OnInit, ViewChild } from '@angular/core';
import { DayBookInputsModel, DayBookList } from '../../models/daybook-model';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { UtilityService } from '../../services/utility-service';
import { DayBookListService } from '../../services/daybook-list-service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { Finyearmst, Txncategory } from '../../models/tallyentry-api-model';
import { ReceiptVerificationResponse } from '../../models/receipt-verification-response.model';
import { VerifyReceiptService } from '../../services/verify-receipt-service';

@Component({
  selector: 'app-receipt-verification',
  templateUrl: './receipt-verification.component.html',
  styleUrls: ['./receipt-verification.component.css'],
})
export class ReceiptVerificationComponent implements OnInit {

verifiedColumns: string[] = [
   'category', 'bookNo', 'receiptNo', 'txnDate', 'purpose', 'modeOfPayment',
  'txnId', 'bank','name', 'mobile', 'pan', 'aadhaar', 'notes', 'amount', 'debitTo', 'creditTo','actions'
];
 displayedColumns: string[] = [
  'category', 'bookNo', 'receiptNo', 'txnDate', 'purpose', 'modeOfPayment',
  'txnId', 'bank','name', 'mobile', 'pan', 'aadhaar', 'notes', 'amount', 'debitTo', 'creditTo','actions'
];

  verifiedData: any[] = []; 
  unverifiedData: any[] = []; 

verifiedDataSource = new MatTableDataSource<any>();
unverifiedDataSource = new MatTableDataSource<any>();

@ViewChild('verifiedPaginator') verifiedPaginator!: MatPaginator;
@ViewChild('unverifiedPaginator') unverifiedPaginator!: MatPaginator;

  public dataSource = new MatTableDataSource<DayBookList>();
  public l_daybookFilteredList: DayBookList[] = [];

  public l_formDataDaybook: DayBookInputsModel = new DayBookInputsModel();
  public l_receiptCount: number = 0;
  public l_totalAmount: number = 0;

  public minDatePicker: Date;
  public maxDatePicker: Date;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public l_categoryList: Txncategory[] = [];
  public l_selectAllClicked: Boolean;

  public l_financialYearList = [];

  constructor(
    private l_UtilityService: UtilityService,
    public l_dayBookListService: DayBookListService,
    private l_datePipe: DatePipe,
    private l_TallyReceiptService: TallyReceiptService,
    private l_ReceiptVerificationService: VerifyReceiptService
  ) {}

  async ngOnInit(): Promise<void> {
    this.l_formDataDaybook = new DayBookInputsModel();
    this.l_selectAllClicked = false;
    this.lFN_GetCategorySelect();
    await this.lFN_FetchDayBookList();
    await this.lFN_GetFinancialYear();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  async lFN_FetchDayBookList() {
    console.log('l_formDataDaybook ==> ', this.l_formDataDaybook);
    if (
      this.l_formDataDaybook.txnCategories?.length === undefined ||
      this.l_formDataDaybook.txnCategories?.length <= 0
    ) {
      console.log('select category to pull listing accounts data');
      this.l_UtilityService.lFN_WarningToaster(
        'Please select category to pull listing accounts',
        ''
      );
      return;
    }

    let l_listPayload = {
      finyearmstId: this.l_formDataDaybook.finyearmstId,
      txnCategories: this.l_formDataDaybook.txnCategories,
    };
    console.log('l_listPayload ==> ', l_listPayload);

    this.l_UtilityService.lFN_ShowLoader();
    let l_dayBookListResponse =
      this.l_dayBookListService.lFN_GetDayBookListCategoryWise(l_listPayload);
    l_dayBookListResponse.subscribe({
      next: async (data) => {
        console.log('Data list_response: ', data);
        if (data.status == 200) {
          //_clear_lists_existing
          this.dataSource.data = [];
          this.l_daybookFilteredList = [];

          let l_list: DayBookList[] = [];
          let l_listOriginal: DayBookList[] = [];
          for await (const iterator of JSON.parse(data.body)) {
            l_listOriginal.push(new DayBookList(iterator));
            let l_formattedAmt =
              this.l_UtilityService.lFN_FormatCurrencyForDisplay(
                iterator.amount
              );
            iterator.amount = l_formattedAmt;
            l_list.push(new DayBookList(iterator));
          }
          this.dataSource.data = l_list;
          this.l_daybookFilteredList = l_listOriginal;
          this.l_UtilityService.lFN_HideLoader();
          await this.lFN_FilterDaybookDetails();
        } else if (data.status == 204) {
          this.l_UtilityService.lFN_WarningToaster(
            'For selected FY Category',
            'Data Not Available'
          );
          this.l_UtilityService.lFN_HideLoader();
          this.dataSource.data = [];
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        // 'Unable to fetch receipts list.'
        this.l_UtilityService.lFN_ErrorToaster(l_error, 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  async lFN_EditReceipt(element: any) {
    console.log('element === ', element);
    console.log('element .accountsheaderId === ', element.accountsheaderId);
    if (element.receiptLocked === true) {
      this.l_UtilityService.lFN_WarningToaster(
        'Cannot Edit Locked Receipt. Delete Tally Mapping on View Tally Transaction Screen',
        'Locked Receipt'
      );
      return;
    }


   // Get system params
  const systemParams = JSON.parse(sessionStorage.getItem('system_params'));

  // We ONLY consider these two roles
  const isAdmin = systemParams?.isRoleAccountsAdmin === true;
  const isSuperAdmin = systemParams?.isRoleAccountsSuperadmin === true;

  // Verified flag
  const isVerified = element.isVerified === true;


  if (isVerified) {
    // Verified Tab → ONLY SuperAdmins can edit/unverify
    if (!isSuperAdmin) {
      this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins can edit verified receipts.',
        'Permission Denied'
      );
      return;
    }
  } else {
    // Unverified Tab → ONLY Admins and SuperAdmins may edit
    if (!isAdmin && !isSuperAdmin) {
      this.l_UtilityService.lFN_WarningToaster(
        'Only admins and superadmins can edit unverified receipts.',
        'Permission Denied'
      );
      return;
    }
  }

    this.l_UtilityService.lFN_ShowLoader();
    let l_accountsHeader = this.l_dayBookListService.lFN_GetAccountHeaderById(
      element.accountsheaderId
    );
    l_accountsHeader.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          this.l_UtilityService.lFN_NavigateViaExtras(
            'tallyentry',
            JSON.parse(data.body),
            'edit'
          );
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster(
          'Unable to fetch receipts by id.',
          'Failure'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  async lFN_ViewReceipt(element: any) {
    let l_accountsHeader = this.l_dayBookListService.lFN_GetAccountHeaderById(
      element.accountsheaderId
    );
    l_accountsHeader.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          console.log('success_response: ', data);
          this.l_UtilityService.lFN_ShowPopup(
            'Receipt Details',
            JSON.parse(data.body)
          );
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster(
          'Unable to fetch receipts by id.',
          'Failure'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  async lFN_FilterDaybookDetails() {
    let l_formData = this.l_formDataDaybook;
    //console.log('l_formData == ', l_formData);
    let l_selectedDate = this.l_datePipe.transform(
      l_formData.txndate,
      'yyyy-MM-dd'
    );
    //console.log('l_selectedDate ===> ', l_selectedDate);

    let l_filteredList = this.l_daybookFilteredList.filter((daybookrow) => {
      let l_status = true;

      if (l_formData.narration) {
        if (
          !daybookrow.narration
            .toLowerCase()
            .includes(l_formData.narration.toLowerCase())
        ) {
          l_status = false;
        }
      } else if (l_formData.receiptNo) {
        if (
          !daybookrow.receiptNo
            .toLowerCase()
            .includes(l_formData.receiptNo.toLowerCase())
        ) {
          l_status = false;
        }
      } else if (l_formData.purpose) {
        if (
          !daybookrow.purpose
            .toLowerCase()
            .includes(l_formData.purpose.toLowerCase())
        ) {
          l_status = false;
        }
      } else if (l_formData.amount) {
        if (daybookrow.amount !== l_formData.amount) {
          l_status = false;
        }
      } else if (l_formData.bookNo) {
        if (daybookrow.bookNo !== l_formData.bookNo) {
          l_status = false;
        }
      } else if (l_formData.txndate) {
        const l_rowDateModified = this.convertToDate(daybookrow.txndate);
        let l_rowDate = this.l_datePipe.transform(
          l_rowDateModified,
          'yyyy-MM-dd'
        );
        //console.log('l_rowDate ===> ', l_rowDate);
        if (l_rowDate !== l_selectedDate) {
          l_status = false;
        }
      }

      return l_status;
    });
    //console.log('l_filteredList == ', l_filteredList);
    this.dataSource.data = l_filteredList;
    this.l_receiptCount = l_filteredList.length;
    await this.lFN_CalculateTotalAmount(l_filteredList);
  }

  async lFN_CalculateTotalAmount(l_filteredList: DayBookList[]) {
    let l_sum: number = 0;
    for await (const iterator of l_filteredList) {
      l_sum = l_sum + iterator.amount;
    }
    this.l_totalAmount = l_sum;
  }

  private convertToDate(dateString: string): Date | null {
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }

  lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          console.log('success_response: ', JSON.parse(data.body));
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categoryList = l_categoryResponseList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        console.error('error_response: ', l_error);
        this.l_UtilityService.lFN_ErrorToaster(
          'Unable to fetch category list.',
          'Failure'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        console.log('Request completed');
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  async lFN_FetchAllDatalist() {
    this.l_formDataDaybook.txnCategories = this.l_categoryList.map(
      (cat) => cat.txncategoryId
    );
    await this.lFN_FetchDayBookList();
  }

  lFN_GetFinancialYearText(finyearmstId: number) {
    if (finyearmstId) {
      const year = this.l_financialYearList.find(
        (year) => year.finyearmstId === finyearmstId
      );
      return year ? year.finyear : '';
    }
  }

  async lFN_GetFinancialYear() {
    let l_finyearResponse = this.l_TallyReceiptService.lFN_GetFinyearmst();
    l_finyearResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_financialYearList: Finyearmst[] = [];
          for await (const l_finyear of JSON.parse(data.body)) {
            l_financialYearList.push(new Finyearmst(l_finyear));
          }
          this.l_financialYearList = l_financialYearList;
          console.log(this.l_financialYearList);
          this.l_UtilityService.lFN_HideLoader();
          this.l_formDataDaybook.finyearmstId = this.l_financialYearList.find(
            (year) => year.status === true
          )?.finyearmstId;
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Unable to fetch Financial Year',
          'Failure'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  async lFN_SetFinancialMinMaxDates() {
    const activeFinyear = JSON.parse(
      sessionStorage.getItem('system_params')
    )?.finyearmst;

    if (activeFinyear && activeFinyear.finyear) {
      const [startYearStr, endYearStr] = activeFinyear.finyear.split('-');

      const startYear = parseInt(`${startYearStr}`);
      const endYear = parseInt(`20${endYearStr}`);

      this.minDatePicker = new Date(startYear, 3, 1);
      this.maxDatePicker = new Date(endYear, 2, 31);
      console.log(
        'minDatePicker and maxDatePicker ==> ',
        this.minDatePicker + ' ' + this.maxDatePicker
      );
    }
  }

  l_ChangeStatus(element: any): void {
    const systemParams = JSON.parse(sessionStorage.getItem('system_params'));
    if (!systemParams?.isRoleAccountsSuperadmin) {
      this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins can change status.',
        'Permission Denied'
      );
      return;
    }
    const newStatus = !element.status;
    const statusLabel = newStatus ? 'Active' : 'Inactive';
    const l_receiptNo = element.receiptNo.replace(/^[A-Za-z]+/, '');

    const dialogData = {
      title: `Change Receipt Status - ${element.receiptNo}`,
      message: `Are you sure you want to change this receipt status to ${statusLabel} ?`,
      buttons: [
        {
          label: 'Yes',
          value: true,
          color: 'primary',
          className: 'btn-yes-custom',
        },
        { label: 'No', value: false, color: 'warn' },
      ],
    };

    this.l_UtilityService
      .lFN_ShowConfirmationDialog(
        dialogData.title,
        dialogData.message,
        dialogData.buttons
      )
      .subscribe((confirmed) => {
        if (confirmed) {
          this.l_dayBookListService
            .lFN_ToggleReceiptStatus(
              element.accountsheaderId,
              element.bookNo,
              l_receiptNo
            )
            .subscribe({
              next: (response: any) => {
                element.status = newStatus;
                console.log(
                  response.body?.msg || 'Status updated successfully'
                );
                this.l_UtilityService.lFN_SuccessToaster(
                  response.body?.msg || 'Status updated successfully',
                  'Success'
                );
              },
              error: (err) => {
                const errorMsg = err.error?.msg || 'Failed to change status';
                console.error('Failed to change status', err);
                this.l_UtilityService.lFN_ErrorToaster(errorMsg, 'Error');
              },
            });
        }
      });
  }

async lFN_GetReceiptVerificationList() {
  if (!this.l_formDataDaybook.finyearmstId || 
      !this.l_formDataDaybook.bookNo || 
      !this.l_formDataDaybook.txnCategories?.length) {

    this.l_UtilityService.lFN_WarningToaster("Please fill all required fields.", "");
    return;
  }

  const payload = {
    finyearmstId: this.l_formDataDaybook.finyearmstId,
    bookNo: this.l_formDataDaybook.bookNo,
    txncategoryId: this.l_formDataDaybook.txnCategories[0]
  };

  this.verifiedData = [];
  this.unverifiedData = [];
  this.verifiedDataSource.data = [];
  this.unverifiedDataSource.data = [];

  this.l_UtilityService.lFN_ShowLoader();

  this.l_ReceiptVerificationService.lFN_GetReceiptList(payload).subscribe({
    next: (res) => {
      if (res.status == 200) {
        const response: ReceiptVerificationResponse = JSON.parse(res.body);

        // split lists
        this.verifiedData = response.data.filter((r) => r.isVerified === true);
        this.unverifiedData = response.data.filter(
          (r) => r.isVerified === false
        );

        // bind to table
        this.verifiedDataSource.data = this.verifiedData;
        this.unverifiedDataSource.data = this.unverifiedData;

        // Assign paginator
        setTimeout(() => {
          this.verifiedDataSource.paginator = this.verifiedPaginator;
          this.unverifiedDataSource.paginator = this.unverifiedPaginator;
        });
        this.l_UtilityService.lFN_HideLoader();
      }
    },
    error: (err) => {
      console.error(err);
      this.l_UtilityService.lFN_ErrorToaster(
        'Unable to fetch receipt list',
        'Error'
      );
      this.l_UtilityService.lFN_HideLoader(); 
    },
    complete: () => {
      this.l_UtilityService.lFN_HideLoader();
    },
  });
}

async lFN_MarkReceiptVerified(element: any) {

  const systemParams = JSON.parse(sessionStorage.getItem('system_params'));
  const isAdmin = systemParams?.isRoleAccountsAdmin === true;
  const isSuperAdmin = systemParams?.isRoleAccountsSuperadmin === true;

  // Only Admin + SuperAdmin can verify
  if (!isAdmin && !isSuperAdmin) {
    this.l_UtilityService.lFN_WarningToaster(
      'Only admins and superadmins can verify receipts.',
      'Permission Denied'
    );
    return;
  }

  const accountsheaderId = element.accountsheaderId;
  const bookNo = element.bookNo;
  const receiptNo = element.transaction?.receiptId;

  const dialogData = {
    title: `Verify Receipt - ${element.transaction?.receiptIdPrefixed || element.receiptNo}`,
    message: `Are you sure you want to mark this receipt as verified?`,
    buttons: [
      {
        label: 'Yes',
        value: true,
        color: 'primary',
        className: 'btn-yes-custom',
      },
      {
        label: 'No',
        value: false,
        color: 'warn'
      }
    ],
  };

  this.l_UtilityService
    .lFN_ShowConfirmationDialog(
      dialogData.title,
      dialogData.message,
      dialogData.buttons
    )
    .subscribe((confirmed) => {
      if (!confirmed) return;

      // Proceed only if user clicked YES
      this.l_UtilityService.lFN_ShowLoader();

      const verifyCall = this.l_ReceiptVerificationService.lFN_MarkVerified(
        accountsheaderId,
        bookNo,
        receiptNo
      );

      verifyCall.subscribe({
        next: async (data) => {
          if (data.status == 200) {
            this.l_UtilityService.lFN_SuccessToaster(
              'Receipt marked as verified successfully.',
              'Success'
            );
            
            // Refresh list
            this.lFN_GetReceiptVerificationList();
          }
        },
        error: (err) => {
          console.error('error_response:', err);

          this.l_UtilityService.lFN_ErrorToaster(
            err.error?.msg || 'Unable to mark receipt as verified.',
            'Failure'
          );

          this.l_UtilityService.lFN_HideLoader();
        },
        complete: () => {
          this.l_UtilityService.lFN_HideLoader();
        }
      });
    });
}

}
